// extracted by mini-css-extract-plugin
export default {"singleInfoWrap":"infoText_singleInfoWrap__1+cPO","preInfoText":"infoText_preInfoText__1YlhT","infoText":"infoText_infoText__Cy1qT"};